import React, { useEffect, useMemo, useRef } from 'react'
import { Polyline as LeafletPolyline } from 'leaflet'
import { Polyline } from 'react-leaflet/Polyline'
import polyUtil from 'polyline-encoded'

type Props = {
  geometry: string;
  color: string;
  isSelected: boolean;
}

const RoutePolyline = React.memo(({ geometry, color, isSelected }: Props) => {
  const polylineRef = useRef<LeafletPolyline>(null)
  const positions = useMemo(() => polyUtil.decode(geometry), [geometry])

  useEffect(() => {
    if (isSelected) polylineRef.current?.bringToFront()
  }, [isSelected])

  return (
    <>
      <Polyline positions={positions} pathOptions={{ color: 'white', weight: 7, opacity: 0.6 }} />
      <Polyline ref={polylineRef} positions={positions} pathOptions={{ color, weight: 4 }} />
    </>
  )
})

export default RoutePolyline
